import { ILanguages, TLanguageIDs } from 'types';
import LabelField from './components/LabelField';
import TextField from './components/ValueField';
import React from 'react';
import style from './WordingField.module.scss';

interface IWordingField {
	languageData: ILanguages;
	changeLabels: (languageId: TLanguageIDs, value: string) => void;
	changeValues: (languageId: TLanguageIDs, value: string) => void;
}

const WordingField: React.FC<IWordingField> = ({ languageData, changeValues, changeLabels }) => {
	return (
		<div className={style.container}>
			<LabelField languageData={languageData} changeLabels={changeLabels} />
			<TextField languageData={languageData} changeValues={changeValues} />
		</div>
	);
};

export default React.memo(WordingField);
